/* tslint:disable:max-line-length */
import { Component, Input, Output, EventEmitter } from '@angular/core';
/**
 * @hidden
 */
var TagListComponent = /** @class */ (function () {
    function TagListComponent() {
        this.removeTag = new EventEmitter();
    }
    TagListComponent.prototype.tagText = function (tag) {
        return tag[this.textField] ? tag[this.textField] : tag;
    };
    TagListComponent.prototype.deleteTag = function (event, tag) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.disabled && event.which === 1) {
            this.removeTag.emit(tag);
        }
    };
    TagListComponent.prototype.itemId = function (focused, index) {
        return focused === index ? this.activeId : undefined;
    };
    TagListComponent.prototype.isGroupTag = function (tag) {
        return tag instanceof Array;
    };
    TagListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-taglist',
                    template: "\n        <ul role=\"listbox\" class=\"k-reset\">\n            <li *ngFor=\"let tag of tags; let i = index;\"\n                [ngClass]=\"{'k-button': true, 'k-state-focused': i === focused }\"\n                [attr.id]=\"itemId(focused, i)\"\n            >\n                <ng-template *ngIf=\"isGroupTag(tag); then groupTag else singleTag\"></ng-template>\n                    <ng-template #groupTag>\n                        <span>\n                            <ng-template *ngIf=\"groupTemplate\"\n                                [templateContext]=\"{\n                                templateRef: groupTemplate.templateRef,\n                                $implicit: tag\n                            }\">\n                            </ng-template>\n                            <ng-template [ngIf]=\"!groupTemplate\">{{ tag.length }} {{ tag.length === 1 ? 'item' : 'items' }} selected</ng-template>\n                        </span>\n                    </ng-template>\n                    <ng-template #singleTag>\n                        <span>\n                            <ng-template *ngIf=\"template\"\n                                [templateContext]=\"{\n                                templateRef: template.templateRef,\n                                $implicit: tag\n                            }\">\n                            </ng-template>\n                            <ng-template [ngIf]=\"!template\">{{ tagText(tag) }}</ng-template>\n                        </span>\n                    </ng-template>\n\n                <span aria-label=\"delete\" class=\"k-select\">\n                    <span class=\"k-icon k-i-close\" (mousedown)=\"deleteTag($event, tag)\">\n                    </span>\n                </span>\n            </li>\n        </ul>\n  "
                },] },
    ];
    /** @nocollapse */
    TagListComponent.ctorParameters = function () { return []; };
    TagListComponent.propDecorators = {
        'tags': [{ type: Input },],
        'textField': [{ type: Input },],
        'focused': [{ type: Input },],
        'template': [{ type: Input },],
        'groupTemplate': [{ type: Input },],
        'disabled': [{ type: Input },],
        'activeId': [{ type: Input },],
        'removeTag': [{ type: Output },],
    };
    return TagListComponent;
}());
export { TagListComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dropdowns/dist/es/taglist.component.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/taglist.component.js
// module chunks = vendor